import * as React from 'react';

const MicrophoneIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 232 320" {...props}>
        <style>
            {
                '\n        .microphone-illustration_svg__st1{fill:#1e0a3c}.microphone-illustration_svg__st2{fill:#f05537}.microphone-illustration_svg__st4{fill:#324b8c}\n    '
            }
        </style>
        <path
            d="M158 59.4C107.1 1.1 18 9 0 11.3v307.4c64.2-3.3 158.9-30.2 185.9-117.9C213.8 110.2 158 59.4 158 59.4z"
            fill="#dbdae3"
        />
        <path
            className="microphone-illustration_svg__st1"
            d="M142.3 274.9c-16 0-30.4-5.4-43.9-16.4-12-9.8-21.2-22.4-29.3-33.5-9.1-12.4-16.9-23.1-24.1-22.6l-.4-5.9c10.4-.7 18.7 10.7 29.3 25.1 7.9 10.8 16.8 23 28.3 32.4 13 10.7 27 15.6 42.6 15l.2 5.9c-.9-.1-1.8 0-2.7 0z"
        />
        <path
            className="microphone-illustration_svg__st2"
            d="M137.5 115.6s-21.8-.2-19.9-5.5c0 0-18.6 9.1-24.8 15.3-6.2 6.3-14.4 26.5-17.5 36-3.5 10.9-7 30-11.1 38.1C61.9 204.2 28 212.8 0 219v82.9c39.5-17.7 116.3-52.5 122.8-56.9 28.3-19.4 59.9-59.3 59.9-59.3l-45.2-70.1z"
        />
        <path
            className="microphone-illustration_svg__st1"
            d="M210.4 292.1c-1.8 0-3.5-.2-5.3-.6-5.2-1.2-12.6-5-19.1-16-1.4-2.3-2.6-4.8-3.6-7.3-10.3 3.1-22.4 6-37.5 6.6l-.2-5.9c14.1-.5 25.8-3.3 35.6-6.3-2.7-8.2-4.7-17.9-5.8-29.1l5.9-.6c1.1 10.8 3 20.1 5.6 27.9 1.6-.5 3.1-1 4.6-1.5 8-2.7 14.8-5 20.9-5.1 7-.1 12.4 2.6 17 8.6 4.4 5.7 4.6 13 .5 19.3-4.1 6.2-11.1 10-18.6 10zm-22.3-25.7c.9 2.1 1.9 4.1 3.1 6.1 4.3 7.2 9.6 11.8 15.3 13.2 6.6 1.6 13.6-1.1 17.4-6.8 1.3-2 3.8-7.2-.2-12.5-3.5-4.5-7.1-6.4-12.2-6.3-5.1.1-11.3 2.2-19.1 4.8-1.3.5-2.7 1-4.3 1.5zM25.323 44.323l.254-.543 7.886 3.674-.253.543zM24.295 53.035l7.6-.076.006.6-7.6.076zM31.66 37.184l.464-.38 4.821 5.875-.464.38z"
        />
        <circle cx={78.3} cy={71} r={39.8} fill="#59c3a3" />
        <circle
            className="microphone-illustration_svg__st1"
            cx={78.3}
            cy={71}
            r={39.8}
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M56.2 69.8c6.1 1.4 12.3-2.4 13.7-8.6 1.4-6.2-2.4-12.3-8.6-13.7-6.1-1.4-12.3 2.4-13.7 8.6-1.4 6.2 2.4 12.3 8.6 13.7zm4.4-19.1c4.4 1 7.2 5.4 6.2 9.9-1 4.4-5.4 7.2-9.9 6.2s-7.2-5.4-6.2-9.9 5.5-7.2 9.9-6.2z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M55.3 73.5c8.1 1.9 16.3-3.2 18.2-11.4s-3.2-16.3-11.4-18.2C54 42.1 45.8 47.1 44 55.3c-1.9 8.1 3.2 16.3 11.3 18.2zM61.5 47c6.5 1.5 10.5 8 9 14.4-1.5 6.5-8 10.5-14.4 9-6.5-1.5-10.5-8-9-14.4 1.5-6.5 7.9-10.5 14.4-9z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M54.4 77.2c10.2 2.4 20.4-4 22.8-14.2s-4-20.4-14.2-22.8c-3.5-.8-7.2-.6-10.7.6-6 5.2-10.4 12.2-12.5 19.8 1 8.1 6.8 14.7 14.6 16.6zm7.9-33.9c8.5 2 13.8 10.4 11.8 19-2 8.5-10.4 13.8-19 11.8-8.5-2-13.8-10.4-11.8-19 2.1-8.5 10.6-13.7 19-11.8z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M53.6 80.8c12.2 2.8 24.4-4.8 27.2-17 2.8-12.2-4.8-24.4-17-27.2-1.4-.3-2.9-.5-4.3-.5-.6.3-1.1.6-1.7 1-1.4.9-2.8 1.8-4.1 2.9 10.4-2.8 21.2 3.3 24 13.7 2.8 10.4-3.3 21.2-13.7 24S42.8 74.4 40 64c-.1-.5-.3-1.1-.4-1.6-.5 2.3-.8 4.6-1 6.9 3 5.7 8.5 10 15 11.5z"
        />
        <circle
            className="microphone-illustration_svg__st4"
            cx={58.7}
            cy={58.7}
            r={3.9}
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M52.8 84.5c14.2 3.3 28.5-5.6 31.8-19.8 3.2-13.8-5-27.7-18.6-31.5-1.9.6-3.7 1.4-5.4 2.2 12.9 1 22.5 12.1 21.5 25S69.9 82.9 57 81.9c-7.7-.6-14.7-4.9-18.5-11.7 0 2 0 3.9.3 5.9 3.7 4.2 8.5 7.2 14 8.4z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M83 79.6c3.4-14.6 18-23.7 32.5-20.3.3.1.6.2 1 .2-.5-1.7-1.1-3.4-1.9-5.1-14.4 3.9-29.3-4.6-33.2-19-.4-1.4-.6-2.8-.8-4.2-4.6-.2-9.2.3-13.6 1.7 14.3 4.5 22.2 19.7 17.6 34-4.5 14.3-19.7 22.2-34 17.6-4.4-1.4-8.4-3.9-11.6-7.3.8 5.1 2.6 10 5.3 14.4.4.6.8 1.3 1.2 1.9 12.4-8.4 29.2-5.1 37.6 7.3 1.9 2.7 3.2 5.8 3.9 9.1 2.3-.5 4.5-1.2 6.6-2.1-8.8-6.4-13.1-17.5-10.6-28.2z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M65 97.6c-4.8-1.1-9.9-.3-14.1 2.3.8.8 1.6 1.5 2.5 2.2 7.7-4 17.2-1.1 21.3 6.6.4.7.6 1.4.9 2.1 1.1.1 2.2.1 3.4.1-1.9-6.7-7.3-11.7-14-13.3z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M63.3 104.9c-1.9-.5-3.8-.4-5.6.1 3.9 2.4 8.2 4.1 12.8 5-1.7-2.5-4.2-4.4-7.2-5.1z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M64.1 101.3c-3.4-.8-7.1-.4-10.2 1.2 1 .8 2 1.5 3.1 2.2 5.4-1.8 11.4.5 14.2 5.5 1.2.2 2.5.4 3.7.5-1.8-4.7-5.8-8.3-10.8-9.4z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M66.7 90.2c-7.2-1.6-14.7-.2-20.8 3.9.6.9 1.2 1.7 1.9 2.5 10.7-7.1 25.2-4.2 32.3 6.5 1.5 2.2 2.6 4.8 3.3 7.4 1.1-.1 2.1-.3 3.2-.5-2.4-9.8-10.1-17.4-19.9-19.8z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M65.8 93.9c-6-1.4-12.5-.3-17.6 3.2.7.8 1.5 1.6 2.2 2.4 9.2-5.7 21.2-2.8 26.9 6.3 1 1.6 1.7 3.3 2.2 5.1 1.1 0 2.2-.1 3.2-.2-2-8.3-8.5-14.8-16.9-16.8zM57 66.1c4.1 1 8.2-1.6 9.2-5.7.9-4.1-1.6-8.2-5.7-9.2s-8.2 1.6-9.2 5.7c-.9 4.2 1.6 8.3 5.7 9.2zm2.8-11.8c2.4.5 3.9 3 3.3 5.4-.5 2.4-3 3.9-5.4 3.3-2.4-.5-3.9-3-3.3-5.4.5-2.3 3-3.8 5.4-3.3z"
        />
        <circle
            className="microphone-illustration_svg__st4"
            cx={109.4}
            cy={85.7}
            r={3.9}
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M101.5 54.1c4.2 1 8.7.9 12.9-.2-.5-1-1-1.9-1.5-2.9-12.5 2.9-25.1-4.8-28-17.4-.1-.6-.3-1.3-.4-2-1.1-.2-2.2-.3-3.3-.4 1.2 11.3 9.4 20.4 20.3 22.9zM94.6 82.3c-1.8 7.9 2.9 15.9 10.8 18.1 1-.9 1.8-1.8 2.7-2.7-6.6-.8-11.3-6.7-10.5-13.3.8-6.6 6.7-11.3 13.3-10.5.4 0 .9.1 1.3.2 2.1.5 4.1 1.6 5.6 3.1.2-1.2.3-2.5.4-3.8-6.9-4.8-16.3-3.2-21.2 3.7-1.2 1.5-1.9 3.3-2.4 5.2z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M87.3 80.6c-2.3 9.8 2.2 20 11 25l.7-.4c.8-.5 1.6-1.1 2.4-1.6-9.8-4.4-14.2-16-9.8-25.9s16-14.2 25.9-9.8l.6.3c-.1-1.2-.2-2.4-.5-3.7-11.7-4.6-24.9 1.2-29.4 12.9-.4 1.1-.7 2.1-.9 3.2z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M90.9 81.4c-2.1 9 2.6 18.1 11 21.7 1-.7 2-1.5 2.9-2.3-8.3-2.5-13.1-11.3-10.6-19.6s11.3-13.1 19.6-10.6c1.5.5 2.9 1.1 4.2 2v-3.7c-9.3-4.8-20.7-1.2-25.5 8.1-.6 1.4-1.2 2.9-1.6 4.4zM103.2 46.8c2.3.5 4.7.6 7 .3-.8-1.1-1.6-2.1-2.5-3-6.6.1-12.7-4-15-10.2-1.2-.5-2.5-.9-3.7-1.2 1.7 7 7.2 12.5 14.2 14.1z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M86.7 80.4C89.6 67.9 102.2 60 114.8 63c1 .2 1.9.5 2.8.8-.2-1.2-.5-2.4-.8-3.6-.4-.1-.9-.2-1.3-.3-14.2-3.3-28.5 5.5-31.8 19.8-2.5 10.6 1.8 21.7 10.8 27.8 1.1-.5 2.2-1.1 3.3-1.6-9-5.1-13.4-15.5-11.1-25.5z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M98.3 83.1c-1.4 6.1 2.4 12.3 8.6 13.7.5.1 1.1.2 1.7.3.9-1.1 1.8-2.2 2.6-3.3-4.4.9-8.8-1.9-9.8-6.4s1.9-8.8 6.4-9.8c3.6-.7 7.3 1 9 4.2.4-1.3.7-2.7.9-4.1-4.3-4.5-11.6-4.7-16.1-.3-1.7 1.6-2.8 3.5-3.3 5.7zM102.3 50.5c3.3.8 6.8.8 10.2 0v-.1c-.6-1-1.2-1.9-1.8-2.8-10.3 1.6-20-5-22.2-15.2-1.1-.3-2.2-.5-3.4-.7 1.3 9.3 8.2 16.7 17.2 18.8z"
        />
        <path
            className="microphone-illustration_svg__st4"
            d="M111.1 78.2c-4.1-1-8.2 1.6-9.2 5.7s1.6 8.2 5.7 9.2c1.3.3 2.7.3 3.9-.1 2.1-3.2 3.8-6.6 4.9-10.3-.9-2.2-2.9-3.9-5.3-4.5zM108.4 90c-2.4-.5-3.9-3-3.3-5.4.5-2.4 3-3.9 5.4-3.3 2.4.5 3.9 3 3.3 5.4-.6 2.4-3 3.9-5.4 3.3zM104 43.1c1 .2 2.1.4 3.1.4-1.5-1.6-3.2-3.1-5-4.4-1-.5-2-1.1-2.8-1.9-1.9-1.1-3.8-2.2-5.9-3 1.9 4.5 5.9 7.8 10.6 8.9z"
        />
        <path
            className="microphone-illustration_svg__st1"
            d="M43.2 89.5l68.5-41.4c1.1-.7 2.7-.3 3.4.8l.5.8c.7 1.1.3 2.7-.8 3.4L46.3 94.6c-1.1.7-2.7.3-3.4-.8l-.5-.8c-.7-1.3-.4-2.8.8-3.5zM186.3 230.4l-16.9 10.2c-4.1 2.5-9.8.8-13-3.9L71.5 110.4s14.5-5 23.8-10.6c9.4-5.7 21.1-16.5 21.1-16.5l72.5 133.9c2.7 4.8 1.5 10.7-2.6 13.2z"
        />
        <path
            className="microphone-illustration_svg__st2"
            d="M133 124.7c-8.3-14.3-9.6-24-4.4-26.6 2.7-1.4 7.1-.2 10.2 3.5 1.8 2.2 4.5 15 4.5 15M146.2 114.3s3.8-3 7.1-1.5c12.8 5.9 9.4 24 9.4 24s4.9-3.3 7.2-2c15.4 8.8 2 28.7 2 28.7s4.8-.9 6.1.4c10.3 10.4 5.8 23.4 1.2 25.8-7.6 3.8-13.1-18.4-26.3-44.4-4.2-8.2-8.7-15.8-12.5-22.5"
        />
        <path
            className="microphone-illustration_svg__st2"
            d="M138.7 115.5c2.5-3 8.7-7.2 16.8-1.3 8.2 5.9 6.8 12.7 5 15.3-1.2 1.8-34.2 39.8-35.5 41.6-1.2 1.8-7.2 7.4-12.7 3.5-5.7-4.2-2.8-11.5-2.1-12.8.9-1.3 26.2-43.6 28.5-46.3zM156.4 136.1c2.5-2.5 8.4-5.9 15.6.2 7.2 6.1 5.5 12.1 3.7 14.4-1.2 1.6-34 33.7-35.2 35.3-1.2 1.6-7.1 6.2-11.9 2.2-5-4.3-1.9-10.8-1.1-11.9.8-1.1 26.7-38 28.9-40.2zM121.4 101.6c1.5-1.4 7.5-6.9 14.6-2.2s3.7 12.5 2.8 13.9c-.6.9-13.8 13.6-14.5 14.5s-7.6 5.2-12.3 2.1c-5-3.3-2.5-10-2.1-10.7s10.2-16.3 11.5-17.6zM166.5 162.7c2-1.7 6.7-3.8 11.5 1.2s3.1 9.3 1.6 10.9c-1 1.1-27.7 22.5-28.8 23.5-1.1 1.1-5.7 4.1-9 .7-3.4-3.5-.5-8.1.1-8.9.7-.7 22.8-25.9 24.6-27.4z"
        />
        <path
            className="microphone-illustration_svg__st2"
            d="M87.2 133.7c3.1-2.3 17.2-15.2 30.3-17.3 22.5 3.9 36 10.1 48.7 14.1 1.5.5 2.4 2 2.2 3.5-1.1 8.1-7.6 13.1-20.9 12.3-6.6-.5-17.9-1.5-23.8-1.1-4.7 13.7-12.9 48.3-14.1 49.7-1.8 2.3-22.4-61.2-22.4-61.2z"
        />
        <path
            className="microphone-illustration_svg__st1"
            d="M109.7 195.4c-.3 0-.5-.2-.5-.5 0-.1 0-.2.1-.3 1.1-1.3 7.4-17 14-49.4 0-.2.2-.4.5-.4 4.7-.4 12.7.2 19.2.7 1.7.1 3.3.2 4.6.3 6.1.4 11-.5 14.5-2.6 3.2-1.9 5.1-4.9 5.8-8.7.3-1.6-.6-3.1-2.2-3.5-3.5-1.1-6.8-2.3-10.2-3.5-10.4-3.7-21.2-7.5-38-10.4-11.4 1.9-23.4 11.5-27.9 15.1-.6.5-1.5 1.1-1.8 1.4-.2.1-.6.1-.7-.1s-.1-.5.1-.7c.4-.3 1.2-.9 1.8-1.4 4.6-3.7 16.8-13.5 28.5-15.3h.2c16.9 3 27.7 6.8 38.2 10.5 3.5 1.2 6.7 2.4 10.2 3.5 2 .6 3.2 2.7 2.9 4.7-.7 4.2-2.8 7.4-6.3 9.5-3.7 2.2-8.7 3.2-15.1 2.7-1.4-.1-3-.2-4.7-.3-6.3-.5-14-1.1-18.6-.8-6.5 32.3-13 48.2-14.1 49.5h-.5zM44.6 196.4c-6.7.5-12.3 5.6-17.2 15.9-4 8.4-7.3 19.4-10.4 30-4.3 14.7-10.3 31.3-17 36.8v6.9c10.2-4.3 16.9-22.6 22.7-42 5.7-19.2 12.1-41.1 22.3-41.7l-.4-5.9z"
        />
    </svg>
);

MicrophoneIllustrationSvg.displayName = 'MicrophoneIllustrationSvg';
export default MicrophoneIllustrationSvg;
